import { useEffect } from 'react';

let lockCount = 0;

function acquire(): void {
  lockCount += 1;
  if (lockCount === 1) document.body.style.overflow = 'hidden';
}

function release(): void {
  lockCount = Math.max(0, lockCount - 1);
  if (lockCount === 0) document.body.style.overflow = '';
}

/** Locks body scroll while `active` is true; safely nests across components. */
export const useScrollLock = (active: boolean): void => {
  useEffect(() => {
    if (!active) return undefined;
    acquire();
    return release;
  }, [active]);
};

export default useScrollLock;
